import { Injectable, Signal, computed, inject } from '@angular/core';

import { TenantLifecycleStateApiModel } from '../../api';
import { AuthStateService } from './auth-state.service';

@Injectable({ providedIn: 'root' })
export class TenantLifecycleService {
  public readonly state: Signal<TenantLifecycleStateApiModel | null>;
  public readonly isClosing: Signal<boolean>;
  public readonly closingSince: Signal<string | null>;
  public readonly endsAt: Signal<string | null>;
  public readonly canWrite: Signal<boolean>;

  private readonly authState = inject(AuthStateService);

  constructor() {
    this.state = computed(
      () => this.authState.activeTenant()?.lifecycleState ?? null,
    );
    this.isClosing = computed(
      () => this.state() === TenantLifecycleStateApiModel.Closing,
    );
    this.closingSince = computed(
      () => this.authState.activeTenant()?.closingSince ?? null,
    );
    this.endsAt = computed(
      () => this.authState.activeTenant()?.liabilityEndsAt ?? null,
    );
    this.canWrite = computed(() => {
      const state = this.state();

      return state === null || state === TenantLifecycleStateApiModel.Active;
    });
  }
}
